export default __webpack_public_path__ + "static/media/geo_icon.2b85573d.svg";